import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { NetworkService } from '../../shared/services/network.service';
import { AuthStore } from '../../store/auth.store';

/**
 * Permite rutas auxiliares (p. ej. `/configuracion`) con sesión API válida
 * o, sin red, con snapshot de campo — para restablecer simulación offline.
 */
@Injectable({
  providedIn: 'root',
})
export class SesionApiOCampoGuard implements CanActivate {
  private readonly authStore = inject(AuthStore);
  private readonly network = inject(NetworkService);
  private readonly router = inject(Router);

  canActivate(): boolean {
    if (this.authStore.sesionValida()) {
      return true;
    }
    if (this.authStore.debeEntrarRutaDelDiaSinRed(this.network.isOnline())) {
      return true;
    }
    void this.router.navigate(['/login']);
    return false;
  }
}
